export const LAZY_LOAD_OBSERVER_OPTIONS = {
  rootMargin: '300px',
  threshold: 0,
  disconnectOnIntersect: true,
};

export const VIDEO_PLAY_OBSERVER_OPTIONS = {
  rootMargin: '0px',
  threshold: 1.0,
};

export const VIDEO_AUTOPLAY_OBSERVER_OPTIONS = {
  rootMargin: '0px',
  threshold: 0.5,
};

